// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__pJdmw","index":"styles_index__2pT9F"};